
import React from 'react'
import { useQuery } from '@apollo/client/react'
import {Grid,
  Button,
  Card,
  CardContent,
  Typography, Box } from '@mui/material'
// Centralized lodash imports - much cleaner!
import { isEmpty } from '@/utils/lodash'
import { GET_SUBSCRIPTION_PLAN } from '@/housefolios-components/CreateAccount/CreateAccountCard/mutations'
import { currencyFormat, numberFormat } from '@/utils/number'
import { LoadingSkeleton } from '@/housefolios-components/LoadingSkeleton'

function SubscriptionPlanCard({
  activeTab,
  section,
  session,
  toggleSubscribe,
  changePlan,
}) {
  const { loading, error, data } = useQuery(GET_SUBSCRIPTION_PLAN, {
    variables: {
      subscriptionPlan:
        activeTab === 'checkedC'
          ? section.nameMonthly
          : section.nameYearly,
    },
  })
  if (loading)
    return (
      <Grid size={{ sm: 3 }}>
        <LoadingSkeleton variant="plan" />
      </Grid>
    )
  if (error) return <p>Error :(</p>

  const { subscriptionPlan = {} } = data
  return (
    <Grid size={{ sm: 3 }}>
      <Card
        style={{
          margin: 10,
          textAlign: 'center',
          position: 'relative',
        }}
      >
        {activeTab === 'checkedC'
          ? section.nameMonthly === session.me.subscriptionPlan && (
              <Box component="span" sx={{
                position: "absolute",
                zIndex: 8,
                width: 160,
                height: 160,
                overflow: "hidden",
                "& > small": {
                  position: "absolute",
                  display: "block",
                  width: "100%",
                  padding: "0.25rem",
                  textAlign: "center",
                  textTransform: "uppercase",
                  fontWeight: "bold",
                  fontSize: "0.769rem",
                  transform: "rotate(45deg)",
                  boxShadow: "0 3px 6px -3px rgba(7, 9, 25, 0.5)",
                  top: 27,
                  left: 37,
                  color: "#fff",
                  backgroundColor: "#368cff",
                },
                top: 0,
                right: 0,
              }}>
                <small>Current</small>
              </Box>
            )
          : section.nameYearly === session.me.subscriptionPlan && (
              <Box component="span" sx={{
                position: "absolute",
                zIndex: 8,
                width: 160,
                height: 160,
                overflow: "hidden",
                "& > small": {
                  position: "absolute",
                  display: "block",
                  width: "100%",
                  padding: "0.25rem",
                  textAlign: "center",
                  textTransform: "uppercase",
                  fontWeight: "bold",
                  fontSize: "0.769rem",
                  transform: "rotate(45deg)",
                  boxShadow: "0 3px 6px -3px rgba(7, 9, 25, 0.5)",
                  top: 27,
                  left: 37,
                  color: "#fff",
                  backgroundColor: "#368cff",
                },
                top: 0,
                right: 0,
              }}>
                <small>Current</small>
              </Box>
            )}
        <Grid
          container
          direction="column"
          sx={{
            alignItems: 'center',
            justifyContent: 'flex-start',
          }}
        >
          <Grid>
            <Typography
              variant="subtitle1"
              color="textSecondary"

              style={{ marginBottom: -5 }}
              sx={{
                fontWeight: 300,
                textTransform: 'uppercase',
                mt: '1.5rem',
              }}
            >
              {activeTab === 'checkedC'
                ? section.subHeaderMonthly
                : section.subHeaderYearly}
            </Typography>
          </Grid>
          <Grid></Grid>
          <Typography
            variant="h4"
            color="primary"

            sx={{ fontWeight: 700, textTransform: 'uppercase' }}
          >
            {section.label}
          </Typography>
        </Grid>
        <CardContent>
          <Grid
            container
            direction="column"
            spacing={2}
            sx={{
              justifyContent: 'center',
              alignItems: 'center',
            }}
          >
            <Grid>
              <Typography
                variant="h3"

                style={{ marginBottom: -25 }}
                sx={{ fontWeight: 700 }}
              >
                {currencyFormat.format(
                  activeTab === 'checkedC'
                    ? subscriptionPlan.price / 100
                    : subscriptionPlan.price / 100 / 12,
                )}
              </Typography>
            </Grid>
            {section.label !== 'Free' && (
              <Grid>
                <Typography
                  variant="subtitle1"
                  style={{ paddingTop: 0 }}
                >
                  {activeTab === 'checkedC'
                    ? 'PER MONTH'
                    : `${currencyFormat.format(
                        subscriptionPlan.price / 100,
                      )} PER YEAR`}
                </Typography>
              </Grid>
            )}

            {section.label !== 'Free' ? (
              <Grid>
                <Typography>
                  Analyze{' '}
                  <b>
                    {numberFormat.format(
                      subscriptionPlan.propertyCount,
                    )}
                  </b>{' '}
                  Properties/mo
                </Typography>
              </Grid>
            ) : (
              <Grid style={{ marginTop: 30 }}>
                <Typography>
                  *Analyze <b>{section.properties}</b> Properties/mo
                </Typography>
              </Grid>
            )}
            <Grid>
              <Typography>
                Create up to{' '}
                <b>{subscriptionPlan.porfolioCount || 1}</b> portfolio
              </Typography>
            </Grid>
            <Grid>
              <Typography>
                Add <b>{subscriptionPlan.teamCount || 0}</b> team
                members
              </Typography>
            </Grid>
            <Grid>
              <Typography>{section.search}</Typography>
            </Grid>
            <Grid>
              <Typography>{section.analyze}</Typography>
            </Grid>
            <Grid>
              <Typography>{section.comp}</Typography>
            </Grid>
            {section.housefoliosMarketplace && (
              <Grid>
                <Typography>
                  {section.housefoliosMarketplace}
                </Typography>
              </Grid>
            )}
            {subscriptionPlan.marketplaceCount > 0 &&
              subscriptionPlan.marketplaceCount && (
                <Grid>
                  <Typography>
                    Create <b>{subscriptionPlan.marketplaceCount}</b>{' '}
                    Marketplace websites
                  </Typography>
                </Grid>
              )}
          </Grid>
          {((activeTab === 'checkedC' &&
            section.nameMonthly !== session.me.subscriptionPlan) ||
            (activeTab === 'checkedB' &&
              section.nameYearly !== session.me.subscriptionPlan)) &&
            !session.me.activeOrg.currentlyFree && (
              <Grid size={12} style={{ marginTop: 10 }}>
                <Button
                  onClick={
                    isEmpty(session.me.activeOrg.subscriptions)
                      ? toggleSubscribe
                      : changePlan
                  }
                  fullWidth
                  variant="outlined"
                  color="primary"
                >
                  Manage Plan
                </Button>
              </Grid>
            )}
        </CardContent>
      </Card>
    </Grid>
  )
}

export default SubscriptionPlanCard
